import script from "./xitongjieshao.vue?vue&type=script&setup=true&lang=js"
export * from "./xitongjieshao.vue?vue&type=script&setup=true&lang=js"

import "./xitongjieshao.vue?vue&type=style&index=0&id=0a401d8a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a401d8a"]])

export default __exports__